import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Radio,
} from "@mui/material";
import { isSelected } from "./air-system-helper";
import { QUESTIONS } from "./electrical-system-helper";
import { convertToCamelCaseFromUnderScore } from "../../../../../utils";

const CustomCheckBox = ({ label, type, checked, onChange }) => {
  return (
    <FormControlLabel
      control={
        type === "RADIO" ? (
          <Radio checked={checked} onChange={onChange} />
        ) : (
          <Checkbox checked={checked} onChange={onChange} />
        )
      }
      label={convertToCamelCaseFromUnderScore(label)}
    />
  );
};

const ElectricalSystem = ({ checklistDetails, setChecklistDetails }) => {
  const [details, setDetails] = useState(
    checklistDetails?.checkList?.electricalSystem || {}
  );
  const [filteredQuestions, setFilteredQuestions] = useState([]);

  const onChange = (question, option) => {
    const { apiKey } = question;
    const { apiOptionKey } = option;

    if (question.type === "RADIO") {
      details[apiKey] = option.label;
    } else {
      details[apiOptionKey] = !details[apiOptionKey];
    }

    setDetails({ ...details });
  };

  const onTextChange = (option, text) => {
    const { apiOptionKey } = option;
    details[apiOptionKey] = text;
    setDetails({ ...details });
  };

  useEffect(() => {
    const quesArray = QUESTIONS(checklistDetails?.checkList?.electricalSystem);
    const filteredArr = quesArray?.filter((que) => que && que);
    setFilteredQuestions(filteredArr);
  }, [details]);

  useEffect(() => {
    setChecklistDetails((prevVal) => ({
      ...prevVal,
      checkList: {
        ...checklistDetails?.checkList,
        electricalSystem: details,
      },
    }));
  }, [details]);

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Electrical System
      </Typography>

      {filteredQuestions?.map((question, index) => (
        <Box key={question?.label} sx={{ mb: 3, px: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            {index + 1}. {question?.label}
          </Typography>

          <Box display="flex" flexWrap="wrap" gap={2}>
            {question.type === "INPUT" && (
              <TextField
                variant="outlined"
                fullWidth
                type={question.keyboardType || "text"}
                placeholder={question.label}
                value={details[question.apiKey] || ""}
                onChange={(e) =>
                  setDetails({
                    ...details,
                    [question.apiKey]: e.target.value,
                  })
                }
              />
            )}

            {question.options.map((option) => {
              if (option.type === "INPUT") {
                return (
                  <TextField
                    key={option.label}
                    label={option.label}
                    variant="outlined"
                    type={option.keyboardType || "text"}
                    value={details[option.apiOptionKey] || ""}
                    onChange={(e) => onTextChange(option, e.target.value)}
                  />
                );
              }

              return (
                <CustomCheckBox
                  key={option.label}
                  label={option.label}
                  type={question.type}
                  checked={isSelected(details, question, option)}
                  onChange={() => onChange(question, option)}
                />
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ElectricalSystem;
